import { render } from "./IndicatorInfo.vue?vue&type=template&id=4366b4a1"
import script from "./IndicatorInfo.vue?vue&type=script&lang=js"
export * from "./IndicatorInfo.vue?vue&type=script&lang=js"

import "./IndicatorInfo.vue?vue&type=style&index=0&id=4366b4a1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__